import React from 'react';

const BillingReportsPage = () => (
  <div className="container">
    <div className="row">
      <div className="col-xs-12">
        <h1>Billing Reports</h1>
      </div>
    </div>
    <div className="row">
      <div className="col-sm-12">Billing Reports will be coming soon!</div>
    </div>
  </div>
);

export default BillingReportsPage;
